import { createSlice } from '@reduxjs/toolkit';

const reviewSlice = createSlice({
	name: 'reviewsManager',
	initialState: {
		reviews: [],
		activePoint: [],
		tableIndex: 0,
		oldValue: ''
	},
	reducers: {
		setElement(state, action) {
			const userReview = action.payload;
			const id =
				userReview.row && userReview.column
					? `${userReview.row}-${userReview.column}`
					: `${userReview.row}`;

			const existingElementIndex = state.reviews.findIndex(
				(r) => r.id === id
			);
			//Update existing element
			if (existingElementIndex >= 0) {
				if (
					userReview.value &&
					userReview.checked === undefined
				) {
					state.reviews[existingElementIndex] = {
						...userReview,
						id
					};
				} else if (userReview.checked) {
					state.reviews[existingElementIndex] = {
						...userReview,
						id
					};
				} else {
					state.reviews.splice(existingElementIndex, 1);
				}
			}
			//Add the new element
			else {
				state.reviews.push({
					...userReview,
					id
				});
			}
		},
		removeReviews(state) {
			state.reviews = [];
		},
		setActivePoint(state, action) {
			state.activePoint = action.payload;
		},
		setTableIndex(state, action) {
			state.tableIndex = action.payload;
		},
		setOldValue(state, action) {
			state.oldValue = action.payload;
		},
		removeActivePoint(state) {
			state.activePoint = [];
		},
		removeTableIndex(state) {
			state.tableIndex = 0;
		},
		removeOldValue(state) {
			state.oldValue = '';
		}
	}
});

export const reviewActions = reviewSlice.actions;

export default reviewSlice;
